import axios from 'axios'

import { reatailmediaApi as baseAPI } from '../api'

const baseURL = `${baseAPI}/payment`

/**
 * RECHARGE
 */
export const recharge = (
  body: IndustryRecharge,
  headers?: Record<string, string>
) => {
  return axios.post(`${baseURL}/v2/transaction`, body, { headers })
}

export const getTransaction = (id: string) =>
  axios.get<ResponseRecharge>(`${baseURL}/transaction/detail/${id}`)

export default {
  recharge,
  getTransaction
}
